// extracted by mini-css-extract-plugin
export default {"input":"plate-input_input__sE6Pg"};